//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FCImage from '~/components/FCImage.vue';

export default {
  name: 'Workouts4_TrainerBlocks',
  components: {
    FCImage,
  },
  data: () => ({
    content: {
      title: 'Teaching from Experience',
      text: "FightCamp workouts are built and led by real-life fighters. They've put it all on the line and know what it takes to become a champion. You can count on an authentic and demanding experience that will deliver one of the toughest and most well-rounded workouts you'll experience anywhere.",
      trainers: [
        {
          name: 'Coach PJ',
          img: 'v4/fc-workouts-trainer-coachpj-001.jpg',
        },
        {
          name: 'Shanie Smash',
          img: 'v4/fc-workouts-trainer-shanie-001.jpg',
        },
        {
          name: 'Aaron Swenson',
          img: 'v4/fc-workouts-trainer-aaron-001.jpg',
        },
        {
          name: 'Tommy Duquette',
          img: 'v4/fc-workouts-trainer-tommy-001.jpg',
        },
        {
          name: 'Flo Master',
          img: 'v4/fc-workouts-trainer-flo-001.jpg',
        },
      ],
    },
  }),
};
